import {
  ModBaseWidgetCallbacks,
  ModBaseWidgetWfdsProperties,
} from '../mods/modBaseWidget';
import { ModFinancialDecisionProperties } from '../mods/modFinancialDecision';
import { ModImportProperties } from '../mods/modImport';
import { ModLanguageProperties } from '../mods/modLanguage';
import { ModProcessctlProperties } from '../mods/modProcessctl';
import { ModSolutionsProperties } from '../mods/modSolutions';
import { ModVwfsProperties } from '../mods/modVwfs';
import { Widget } from '../Widget';

/**
 * The widget is built with the finAPI WebForm design system, which is themed
 * with a WebForm profile. Therefore the widget does not support the `theme`
 * and `themeOverrides` properties.
 */
export interface FinancialDecisionProperties
  extends ModBaseWidgetWfdsProperties,
    ModProcessctlProperties,
    ModSolutionsProperties,
    ModVwfsProperties,
    ModImportProperties,
    ModLanguageProperties,
    ModFinancialDecisionProperties {}

export type FinancialDecisionCallbacks = ModBaseWidgetCallbacks;

export class FinancialDecision extends Widget<
  FinancialDecisionProperties,
  FinancialDecisionCallbacks
> {
  /**
   * # Financial Decision
   * Guides the end-user through an account analysis and presents the decision
   * of the finAPI Financial Decision Engine. The use case is selected with the
   * mandatory `fdeVariant` property.
   *
   * Note that unlike the other widgets, `useContainedDialogs` defaults to
   * false, so dialogs cover the entire host page unless you set it to true.
   *
   * @param container - parent HTML element where the widget will be injected
   * @param target - URL of the environment from which the widget's JS bundle will be fetched. Use this, for example, when testing features that are only released to the sandbox environment. By default, `https://widget-library-finapi-general-live.finapi.io` is used.
   * @param ownerDocument - parent Document where the widget will be injected. For example, shadow root or document fragment. By default, the default top-level document is used.
   * @param customBundleFileName - allows modifying the filename of the widget's JS bundle that will be fetched. This property is useful during dev mode when widgets are generated together into one `main.js` file.
   */
  constructor(
    container: HTMLElement,
    target?: string,
    ownerDocument?: Document,
    customBundleFileName?: string
  ) {
    super(
      'financial-decision',
      container,
      target,
      ownerDocument,
      customBundleFileName
    );
  }
}
